import { ChangeDetectorRef, Component, Inject, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatDialogContent,
  MatDialogActions,
  FormsModule,
  ReactiveFormsModule,
];

@Component({
  selector: 'cancel-dialog',
  standalone: true,
  imports: [MODULES],
  templateUrl: './cancelDialog.component.html',
  styleUrl: './cancelDialog.component.css',
})
export class CancelDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CancelDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { mode: string }) {
  }

  onYesClick(): void {
    this.dialogRef.close('yes');
  }

  onNoClick(): void {
    this.dialogRef.close('no');
  }

  onOkClick(): void {
    this.dialogRef.close('no');
  }
}
